export default "__VITE_ASSET__DLJY2V$I__"